  import { gsap } from "gsap";
  import { ScrollTrigger } from "gsap/ScrollTrigger.js";

  // Регистрируем плагин
  gsap.registerPlugin(ScrollTrigger);

  // Настраиваем ScrollTrigger для работы с #screen как скроллером
  ScrollTrigger.defaults({
    scroller: "#screen"
  });

// Хранилище для триггеров, привязанных к элементам
const elementTriggers = new WeakMap();

/**
 * Анимация для разбитого на слова текста
 * Вызывается директивой v-text-split для каждого элемента .text-splitted
 */
export function animateLetters(el) {
  // Проверяем что элемент существует и находится в DOM
  if (!el || !el.isConnected) return;

  // Проверяем что scroller существует
  const scroller = document.querySelector('#screen');
  if (!scroller) return;

  // Убиваем предыдущий триггер для этого элемента, если есть
  const existingTrigger = elementTriggers.get(el);
  if (existingTrigger) {
    existingTrigger.kill();
    elementTriggers.delete(el);
  }

  // Находим все .letter2 внутри элемента
  const letters = el.querySelectorAll('.letter2');

  if (!letters.length) return;

  // Находим родителя .text-fade-in для триггера
  const parent = el.closest('.text-fade-in');
  const trigger = parent || el;

  // Проверяем что trigger тоже в DOM
  if (!trigger.isConnected) return;

  // Устанавливаем начальное состояние для букв
  gsap.set(letters, {
    y: 40,
    x: 25,
    skewX: 10,
    autoAlpha: 0,
  });

  // Создаём ScrollTrigger для анимации появления
  const st = ScrollTrigger.create({
    trigger: trigger,
    start: "top bottom",
    once: true,
    onEnter: () => {
      gsap.to(letters, {
        autoAlpha: 1,
        y: 0,
        x: 0,
        skewX: 0,
        duration: 0.5,
        stagger: 0.03,
        ease: "back.out(1.4)",
      });
    }
  });

  // Сохраняем триггер для последующей очистки
  elementTriggers.set(el, st);
}

/**
 * Очищает триггер для элемента (вызывается из директивы unmounted)
 */
export function cleanupLetters(el) {
  const trigger = elementTriggers.get(el);
  if (trigger) {
    trigger.kill();
    elementTriggers.delete(el);
  }
}

export default function init() {

    // ANY ELEMENT INTRO GENERIC
    const elementsIntro = document.querySelectorAll(".element-intro");

    gsap.set(elementsIntro, {autoAlpha: 0, y: 50 });

    ScrollTrigger.batch(elementsIntro, {
      onEnter: batch => {
        gsap.to(batch, {
          autoAlpha: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.08,
          ease: "back.out(1.4)",
        })
      },
      start: "top bottom",
      once: true
    })

    // TEXT FADE IN FULL (для заголовков с полной непрозрачностью)
    const textFadeInFull = document.querySelectorAll(".text-fade-in-full");

    gsap.set(textFadeInFull, {autoAlpha: 0, y: 50 });

    ScrollTrigger.batch(textFadeInFull, {
      onEnter: batch => {
        gsap.to(batch, {
          autoAlpha: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.08,
          ease: "back.out(1.4)",
        })
      },
      start: "top bottom",
      once: true
    })

    // DIVIDER INTRO GENERIC
    const linesIntro = document.querySelectorAll(".lines-intro");

    gsap.set(linesIntro, {width: 0 });

    linesIntro.forEach( (el)=> {
      gsap.to(el, {
        width: "100%",
        autoAlpha: 1,
        duration: 0.5,
        ease: "power2.out",
        scrollTrigger: {trigger: el, start: "top bottom", once: true }
      });
    })

    // Обновляем ScrollTrigger после всех изменений DOM
    ScrollTrigger.refresh();

  }
